import { useEffect } from 'react';
import { useGlobalToast } from '@repo/atomic-components';
import { ENDPOINT_LOCK_REFUSED_EVENT, ENDPOINT_LOCKS, type EndpointLockRefusedDetail } from '@/api';

/** Shows a lock's toast each time something is refused for it (see announceEndpointLockRefusal). Mount once, in App. */
export const useEndpointLockToasts = () => {
  const toastRef = useGlobalToast();

  useEffect(() => {
    const handleEndpointLockRefused = (event: Event) => {
      const { toast } = ENDPOINT_LOCKS[(event as CustomEvent<EndpointLockRefusedDetail>).detail.lockId];

      // One action can be refused several times over; replacing the toast keeps it to one on screen
      toastRef.current?.remove(toast);
      toastRef.current?.show(toast);
    };

    window.addEventListener(ENDPOINT_LOCK_REFUSED_EVENT, handleEndpointLockRefused);

    return () => window.removeEventListener(ENDPOINT_LOCK_REFUSED_EVENT, handleEndpointLockRefused);
  }, [toastRef]);
};
